import React from 'react'
import { Box } from '@chakra-ui/react'
import ReactPlayer from 'react-player'

function VideoPlayer(props) {
  return (
    <Box paddingTop="56.25%" position="relative" {...props}>
      <ReactPlayer
        url={props.url}
        controls
        width="100%"
        height="100%"
        style={{ position: 'absolute', top: 0, left: 0 }}
      />
    </Box>
  )
}

export default VideoPlayer
